import React from 'react'

import FacebookEditSections from '../Sections/FacebookEditSections'
import GoogleEditSections from '../Sections/GoogleEditSections'
import Dv360EditSections from '../Sections/Dv360EditSections'
import TikTokEditSections from '../Sections/TikTokEditSections'

import {
  DV_360_PLATFORM,
  FACEBOOK_PROVIDER_PLATFORM,
  GOOGLE_PROVIDER_PLATFORM,
  TIKTOK_PROVIDER_PLATFORM
} from '../../../../constants/selectLists/platformList'
import { AMOUNT_MICROS, BUDGET_DAILY, BUDGET_LIFETIME, CAMPAIGN_BUDGET } from '../../CampaignForms/fields'
import {
  BUDGET_DAILY_LINE_ITEM,
  BUDGET_LIFETIME_LINE_ITEM
} from '../../CombinedFacebookTiktokCreate/CreateFormSelector/CampaignCreateForm/fields'
import { BUDGET } from '../../../Tiktok/CampaignForms/CampaignTikTokEdit/fields'

const CampaignBudgetEditFormContent = ({ campaign, isEditDataLoading }) => {
  if (
    !campaign?.[BUDGET] &&
    !campaign?.[BUDGET_LIFETIME] &&
    !campaign?.[BUDGET_DAILY] &&
    !campaign?.[BUDGET_LIFETIME_LINE_ITEM] &&
    !campaign?.[BUDGET_DAILY_LINE_ITEM] &&
    // newly google campaign has budget in different field
    !campaign?.[CAMPAIGN_BUDGET]?.[AMOUNT_MICROS]
  ) {
    return <p>There is no budget yet</p>
  }

  switch (campaign?.provider) {
    case FACEBOOK_PROVIDER_PLATFORM:
      return <FacebookEditSections campaign={campaign} isEditDataLoading={isEditDataLoading} />
    case GOOGLE_PROVIDER_PLATFORM:
      return <GoogleEditSections campaign={campaign} isEditDataLoading={isEditDataLoading} />
    case DV_360_PLATFORM:
      return <Dv360EditSections campaign={campaign} isEditDataLoading={isEditDataLoading} />
    case TIKTOK_PROVIDER_PLATFORM:
      return <TikTokEditSections campaign={campaign} isEditDataLoading={isEditDataLoading} />
    default:
      return null
  }
}

export default CampaignBudgetEditFormContent
